import { ConfirmationLineTable } from "./ConfirmationLineTable";
import type { ConfirmationCategoryTableProps, ConfirmationTableColumn } from "./tableTypes";
import { confirmationCrewPricingUnitLabel } from "../../../service/confirmationEditorView";
import { confirmationTablePeopleSource } from "../../../service/confirmationTablePresentation";

/** 独立维护司导角色、计费人数和期间的表格展示。 */
export function ConfirmationCrewTable({ common, table }: ConfirmationCategoryTableProps) {
  const { item, role, billing, quantity, count, price, amount, provider, tail } = common;
  const columns: ConfirmationTableColumn[] = [
    item, { ...role, width: 76 },
    { ...billing, label: "人数来源", width: 108, render: line => <>{confirmationTablePeopleSource(line)}{line.unit === "人" && <small>来源未知</small>}<small>{confirmationCrewPricingUnitLabel(line)}</small></> },
    quantity("计费人数"), count("天 / 晚 / 次数"), price, amount, provider, ...tail,
  ];
  return <ConfirmationLineTable {...table} columns={columns} variant="crew" />;
}
